import { Outlet } from "react-router-dom";
import VendorNavBar from "@/components/vendor/VendorNavBar";
import VendorBadge from "@/components/vendor/VendorBadge";
import ModeSwitcher from "@/components/vendor/ModeSwitcher";

/**
 * VendorLayout — wraps all vendor mode screens with the vendor palette,
 * persistent badge, nav bar, and mode switcher.
 */
export default function VendorLayout() {
  return (
    <div className="min-h-screen bg-[#1C1C1E] text-white" data-testid="vendor-layout">
      <VendorBadge />
      <ModeSwitcher />
      <div className="pb-20">
        <Outlet />
      </div>
      <VendorNavBar />
    </div>
  );
}
